// Central content for the Gatherings journal.
// To add a future gathering, append an object below — the pages generate automatically.
// status: "past" | "upcoming". Images can be remote URLs or local /public paths.

export const GATHERINGS = [
  {
    slug: "full-moon-ritual",
    title: "Harvest Within",
    subtitle: "A Full Moon Gathering",
    tagline: "What are you ready to harvest?",
    date: "Saturday, 26 September",
    dateISO: "2026-09-26",
    time: "7:00 – 9:30 PM",
    status: "upcoming",
    location: "Villa Gaia · San Roque",
    excerpt:
      "An intimate evening under the full moon — guided meditation, conscious movement, music and connection. A space to slow down, reconnect and honour what has grown within you.",
    cover: "https://images.unsplash.com/photo-1613068431228-8cb6a1e92573?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    hero: "https://images.pexels.com/photos/20087034/pexels-photo-20087034.jpeg?auto=compress&cs=tinysrgb&w=2000",
    lead: [
      "Join us for an intimate evening under the full moon — a space to slow down, reconnect and honour what has grown within you.",
      "Through guided meditation, conscious movement, music and connection, we will explore what is ready to be gathered, what can be released, and what you would like to create space for next.",
    ],
    details: [
      "Guided meditation",
      "Conscious movement",
      "Live music",
      "Heartfelt connection",
    ],
    practical: [
      { label: "When", value: "Saturday, 26 September · 7:00 – 9:30 PM" },
      { label: "Where", value: "Villa Gaia · San Roque" },
      { label: "Contribution", value: "€50 — includes a drink and a shared food offering" },
      { label: "Spaces", value: "Limited · advance reservation required" },
    ],
    contribution: "€50 · a drink & shared food offering included",
    invite: "Come as you are.",
    note: "A space to remember who you are.",
    reflection: [],
    gallery: [],
    video: null,
  },
  {
    slug: "villa-gaia-house-blessing-opening",
    title: "Villa Gaia House Blessing Opening",
    date: "July 2026",
    dateISO: "2026-07-01",
    status: "past",
    location: "Villa Gaia · Southern Spain",
    excerpt:
      "Our first evening at Villa Gaia — beautiful souls, conscious breath, free movement, music and heartfelt connection.",
    cover: "/gatherings/villa-gaia-opening/g5.jpg",
    hero: "/gatherings/villa-gaia-opening/g4.jpg",
    lead: [
      "Our first Villa Gaia gathering was everything I had hoped for… and more.",
    ],
    reflection: [
      "An evening filled with beautiful souls, heartfelt conversations, conscious breathing, free movement, music, laughter, and meaningful connections.",
      "Thank you to everyone who came with an open heart and helped bring this dream to life.",
      "This is just the beginning.",
    ],
    video: null,
    gallery: [
      { src: "/gatherings/villa-gaia-opening/g4.jpg", alt: "A blessing offering carried through the garden", orientation: "landscape" },
      { src: "/gatherings/villa-gaia-opening/g6.jpg", alt: "Music and laughter at the decks", orientation: "portrait" },
      { src: "/gatherings/villa-gaia-opening/g10.jpg", alt: "Conversations as the sun sets", orientation: "landscape" },
      { src: "/gatherings/villa-gaia-opening/g3.jpg", alt: "A heartfelt embrace at golden hour", orientation: "portrait" },
      { src: "/gatherings/villa-gaia-opening/g1.jpg", alt: "Crystals, roses and shells gathered on the altar", orientation: "landscape" },
      { src: "/gatherings/villa-gaia-opening/g7.jpg", alt: "A tender moment with a furry friend", orientation: "portrait" },
      { src: "/gatherings/villa-gaia-opening/g8.jpg", alt: "Walking the garden at golden hour", orientation: "portrait" },
      { src: "/gatherings/villa-gaia-opening/g2.jpg", alt: "Singing bowls and a lotus candle", orientation: "landscape" },
      { src: "/gatherings/villa-gaia-opening/g5.jpg", alt: "Gathered in white on the grass", orientation: "portrait" },
      { src: "/gatherings/villa-gaia-opening/g9.jpg", alt: "Friends gathered on the lawn", orientation: "landscape" },
    ],
  },
];

const order = (a, b) => {
  // Past gatherings (the real, photographed events) are the protagonists and come first;
  // upcoming announcements follow.
  if (a.status !== b.status) return a.status === "past" ? -1 : 1;
  const da = new Date(a.dateISO).getTime();
  const db = new Date(b.dateISO).getTime();
  return a.status === "past" ? db - da : da - db;
};

export const getGatherings = () => [...GATHERINGS].sort(order);

export const getGathering = (slug) => GATHERINGS.find((g) => g.slug === slug) || null;

export const getAdjacent = (slug) => {
  const list = getGatherings();
  const i = list.findIndex((g) => g.slug === slug);
  return {
    prev: i > 0 ? list[i - 1] : null,
    next: i >= 0 && i < list.length - 1 ? list[i + 1] : null,
  };
};
